import { useState } from "react";
import { useMutation } from "react-query";
import { sendToken as sendTokenReq } from "src/service/sessions";
import { notifySuccess } from "src/components/Common/Toast";
import { useTranslation } from "react-i18next";

interface IUseSendTokenProps {
  onSuccess?: () => void;
  onError?: () => void;
}
export function useSendToken({ onSuccess, onError }: IUseSendTokenProps) {
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const { t } = useTranslation();
  const { isLoading: isSendTokenLoading, mutateAsync: mutateSendToken } =
    useMutation("sendToken", sendTokenReq, {
      onSuccess: (res) => {
        notifySuccess(t("logIn.signUp.otp.sendTokenMsg"));
        setIsSuccess(true);
      },
      onError: onError ? onError : () => {},
    });

  return { isSuccess, isSendTokenLoading, mutateSendToken };
}
